import { INGESTION_SOURCE } from './constants';
import type { FileNode } from './DataRoom';

/** Bank-account folders hold bank statements; a provisional-financials file moved in is not one. */
export const isBankStatementFile = (file: FileNode): boolean =>
    file.metaData?.fileMetaData?.ingestionSource !== INGESTION_SOURCE.PROVISIONAL_FINANCIALS;
